module.exports = __webpack_public_path__ + "static/media/independent.fd8616ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/independent.png
// module id = 1803
// module chunks = 146